"use client";
import {
  useHovercardStoreProps
} from "./ZU7LQC5V.js";
import {
  useStore,
  useStoreProps
} from "./EKQEJRUF.js";

// src/tooltip/tooltip-store.ts
import * as Core from "@ariakit/core/tooltip/tooltip-store";
function useTooltipStoreProps(store, update, props) {
  store = useHovercardStoreProps(store, update, props);
  useStoreProps(store, props, "type");
  useStoreProps(store, props, "skipTimeout");
  return store;
}
function useTooltipStore(props = {}) {
  const [store, update] = useStore(Core.createTooltipStore, props);
  return useTooltipStoreProps(store, update, props);
}

export {
  useTooltipStoreProps,
  useTooltipStore
};
